module.exports = __webpack_public_path__ + "static/img/FinishNoWord.3a8ef22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FinishNoWord.jpg
// module id = sJ5x
// module chunks = 1